// extracted by mini-css-extract-plugin
export default {"FullWidthButton":"igfyS_3QvdAs6YkBvThR"};